import { Link } from "react-router-dom";
import { animeCategories } from "@/mocks/anime";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">51动漫</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              51动漫官网——提供51动漫在线观看和51动漫下载服务，涵盖日漫、韩漫、国漫以及剧场版动漫全集，支持下拉式阅读，免费追更好看的动漫。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors">首页</Link>
              {animeCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">热门推荐</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/article/1" className="text-sm text-white/60 hover:text-white transition-colors">鬼灭之刃 柱训练篇</Link>
              <Link to="/article/2" className="text-sm text-white/60 hover:text-white transition-colors">咒术回战 第二季</Link>
              <Link to="/article/4" className="text-sm text-white/60 hover:text-white transition-colors">我独自升级</Link>
              <Link to="/article/5" className="text-sm text-white/60 hover:text-white transition-colors">完美世界</Link>
              <Link to="/article/3" className="text-sm text-white/60 hover:text-white transition-colors">葬送的芙莉莲</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-white/60 hover:text-white transition-colors">品牌介绍</Link>
              <a href="/about#contact" className="text-sm text-white/60 hover:text-white transition-colors">联系我们</a>
              <span className="text-sm text-white/40">客服邮箱：service@51anime.com</span>
              <span className="text-sm text-white/40">工作时间：9:00 - 22:00</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} 51动漫官网 版权所有 | 本站所有资源均来自网络，仅供学习交流
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}